module.exports = __webpack_public_path__ + "img/icone-manual.53a1d5b1.svg";